<script>
    import { List, DemoButton } from '@/components'

    export let items = []
    export let title = ''
    export let circleColor = '#000000'
    export let direction = 'left'
    export let videoName
</script>

<div class="wrapper">
    <div class="content content-{direction}"
        class:content-left={direction === 'left'}
        class:content-right={direction === 'right'}
    >
        <div class="list">
            <List {items} {circleColor} {title} />
        </div>

        <div class="button-wrapper">
            <DemoButton />
        </div>
        <div class="after-button-desktop">
            <slot name="afterButton" />
        </div>
    </div>

    <div class="iphone">
        <video class="video" controls>
            <source src={`./video/${videoName}.mp4`} type="video/mp4">
        </video>
    </div>
</div>

<div class="after-button-adaptive">
    <slot name="afterButton" />
</div>

<style lang="scss" module>
    .title {
        line-height: 60px;
    }

    .wrapper {
        display: flex;

        @media (max-width: 935px) {
            flex-direction: column;
        }

        .content {

            @media (max-width: 1024px) {
                max-width: 470px;
            }

            @media (max-width: 935px) {
                margin: 0 auto;
                order: 2;
            }

            &.content-right {
                margin-left: 100px;
                order: 2;

                @media (max-width: 935px) {
                    margin: 0 auto;
                }
            }

            .button-wrapper {
                margin-top: 75px;
                margin-bottom: 171px;
            }
        }

        .iphone {
            position: relative;
            background-image: url('../img/iphone.png');
            background-repeat: no-repeat;
            background-size: contain;
            width: 500px;
            height: 860px;

            @media (max-width: 1024px) {
                margin-left: -100px;
            }

            @media (max-width: 935px) {
                margin: 0 auto;
                order: 1;
            }

            @media (max-width: 600px) {
                margin-left: -8vw;
                width: 400px;
                height: 554px;
            }

            .video {
                position: absolute;
                left: 150px;
                top: 24px;
                width: 331px;
                height: 715px;
                border-radius: 40px;
                object-fit: fill;

                @media (max-width: 600px) {
                    left: 95px;
                    top: 15px;
                    width: 215px;
                    height: 461px;
                    border-radius: 25px;
                }
            }
        }
    }

    .after-button-adaptive {
        display: none;
    }

    @media (max-width: 834px) {
        .content {
            width: 50%;

            br {
                display: none;
            }
        }

        .after-button-desktop {
            display: none;
        }

        .after-button-adaptive {
            display: block;
            margin-top: 64px;

            br {
                display: none;
            }
        }
    }

    @media (max-width: 420px) {
        .wrapper {
            
            .content {
                width: 100%;

                .list {
                    padding-left: 20px;
                }

                .button-wrapper {
                    margin-bottom: 0;
                }
            }
        }

        .after-button-adaptive {
            margin-top: 50px;
        }
    }
</style>